import { MERCHANT_ADMIN_ACCOUNT } from "constants/action-types";
import { MEDIA_TYPE_IMAGE } from "constants/media";
import { IMerchant, IMerchantBasicProfile } from "constants/merchants";
import type { IAction, IFetchParams } from "epics/base-epic";
import { Dispatch } from "react";
import siteConfig from "site-config";

const FetchParams = {
    merchantMutate: (merchantId: string, merchant: Partial<IMerchant>): IFetchParams => ({
        method: "PATCH",
        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}`,
        body: {
            ...merchant,
            field_mask: {
                paths: ["name"],
            },
        },
    }),
    merchantBasicProfileMutate: (
        merchantId: string,
        merchantBasicProfile: Partial<IMerchantBasicProfile>
    ): IFetchParams => ({
        method: "PATCH",
        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/basic_profile`,
        body: {
            merchant_basic_profile: merchantBasicProfile,
            field_mask: {
                paths: [
                    "mobile_phone",
                    "phone",
                    "website",
                    "facebook_url",
                    "instagram_url",
                    "linkedin_url",
                    "pinterest_url",
                    "description",
                    "email",
                    "tax_id",
                    "post_office_box",
                    "country",
                    "street",
                    "city",
                    "state",
                    "postal_code",
                ],
            },
        },
    }),
};

export interface IMutateMerchantWithBasicProfileAction
    extends IAction<{
        merchantFetchParams: IFetchParams;
        merchantBasicProfileFetchParams: IFetchParams;
    }> {}

export const fetchMerchant = (merchantId: string) => ({
    type: MERCHANT_ADMIN_ACCOUNT.MERCHANT.FETCH.START,
    payload: {
        method: "GET",
        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}`,
    },
});

export const fetchMerchantBasicProfile = (merchantId: string) => ({
    type: MERCHANT_ADMIN_ACCOUNT.MERCHANT_BASIC_PROFILE.FETCH.START,
    payload: {
        method: "GET",
        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/basic_profile`,
    },
});

export const fetchMerchantWithBasicProfile = (merchantId: string) => (dispatch: Dispatch<IAction<IFetchParams>>) => {
    dispatch(fetchMerchant(merchantId));
    dispatch(fetchMerchantBasicProfile(merchantId));
};

export const mutateMerchant = (merchantId: string, merchant: Partial<IMerchant>) => ({
    type: MERCHANT_ADMIN_ACCOUNT.MERCHANT.MUTATE.START,
    payload: FetchParams.merchantMutate(merchantId, merchant),
});

export const mutateMerchantBasicProfile = (
    merchantId: string,
    merchantBasicProfile: Partial<IMerchantBasicProfile>
) => ({
    type: MERCHANT_ADMIN_ACCOUNT.MERCHANT_BASIC_PROFILE.MUTATE.START,
    payload: {
        method: "PATCH",
        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/basic_profile`,
        body: FetchParams.merchantBasicProfileMutate(merchantId, merchantBasicProfile),
    },
});

export const mutateMerchantWithBasicProfile = (
    merchantId: string,
    merchant: IMerchant,
    merchantBasicProfile: IMerchantBasicProfile
): IMutateMerchantWithBasicProfileAction => ({
    type: MERCHANT_ADMIN_ACCOUNT.MERCHANT.MUTATE_WITH_BASIC_PROFILE,
    payload: {
        merchantFetchParams: FetchParams.merchantMutate(merchantId, merchant),
        merchantBasicProfileFetchParams: FetchParams.merchantBasicProfileMutate(merchantId, merchantBasicProfile),
    },
});

export const deactivateMerchant = (merchantId: string) => ({
    type: MERCHANT_ADMIN_ACCOUNT.MERCHANT.DEACTIVATE.START,
    payload: {
        method: "PATCH",
        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/deactivate`,
    },
});

export const activateMerchant = (merchantId: string) => ({
    type: MERCHANT_ADMIN_ACCOUNT.MERCHANT.ACTIVATE.START,
    payload: {
        method: "PATCH",
        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/activate`,
    },
});

export const mutateMerchantLogo = (merchantId: string, upload_id: string) => ({
    type: MERCHANT_ADMIN_ACCOUNT.MERCHANT_BASIC_PROFILE.UPDATE_LOGO,
    payload: {
        method: "PATCH",
        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/logo`,
        body: {
            kind: MEDIA_TYPE_IMAGE,
            media_resource: {
                image: {
                    upload_id,
                },
            },
        },
    },
    meta: {
        merchantId,
    },
});
